import $ from "jquery";

Drupal.behaviors.siwertellformButtonValidation = {
  attach: function (context) {
    $(document).ready(function () {
      $('.ui-dialog .js-form-submit').addClass('btn--disabled'); 

      $('.ui-dialog .form-item > input').on('click', () => { 
        if($('.form-item-gdpr input').is(':checked')) {
          $('.ui-dialog .js-form-submit').removeClass('btn--disabled');

        } else {
          $('.ui-dialog .js-form-submit').addClass('btn--disabled'); 
        }
      });
    });
  },
};
